module.exports = __webpack_public_path__ + "static/media/uninow_logo_vertical_white.2b66950d.svg";